'use client';

import { c as _c } from "react/compiler-runtime";
import ReactCountryFlag from 'react-country-flag';
import { countryListWithFlags } from '@repo/features/country/data';
import { Button, Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, InputGroupAddon, InputGroupButton, Popover, PopoverContent, PopoverTrigger } from '@repo/ui/components/start';
import { CheckIcon, ChevronsUpDown } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { usePhoneInput } from './context';
export interface PhoneInputCountrySelectProps {
  className?: string;
  showChevron?: boolean;
  showCode?: boolean;
}
export function PhoneInputCountrySelect(t0) {
  const $ = _c(61);
  const {
    className,
    showChevron: t1,
    showCode: t2
  } = t0;
  const showChevron = t1 === undefined ? true : t1;
  const showCode = t2 === undefined ? false : t2;
  const {
    actions,
    state
  } = usePhoneInput();
  const {
    country,
    countryName,
    countryOpen,
    disabled,
    inputVariant,
    layout
  } = state;
  const isGhost = inputVariant === "ghost";
  let t3;
  if ($[0] !== country || $[1] !== countryName || $[2] !== countryOpen || $[3] !== isGhost || $[4] !== layout) {
    t3 = country ? <span className="inline-flex h-4 w-6 items-center justify-center overflow-hidden rounded-sm [&_svg:not([class*='size-'])]:size-full"><ReactCountryFlag aria-label={`Flag of ${countryName}`} countryCode={country} title={countryName} /></span> : <span className={cn("inline-flex h-4 w-6 items-center justify-center overflow-hidden rounded-sm text-xs text-muted-foreground", isGhost && !countryOpen && "w-0 group-focus-within/input-group:w-6", isGhost && !countryOpen && layout === "button-group" && "group-focus-within/phone-input:w-6")}><div className="size-3.5 bg-border" /></span>;
    $[0] = country;
    $[1] = countryName;
    $[2] = countryOpen;
    $[3] = isGhost;
    $[4] = layout;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const flag = t3;
  const hideEmptyGhost = isGhost && !country && !countryOpen;
  let t4;
  if ($[6] !== countryOpen || $[7] !== isGhost || $[8] !== layout || $[9] !== showChevron) {
    t4 = showChevron && (isGhost ? <span className={cn("inline-flex w-0 scale-95 items-center justify-center overflow-hidden opacity-0 transition-[width,margin,opacity,transform] duration-150 ease-out", layout === "button-group" && "group-focus-within/phone-input:w-3.5 group-focus-within/phone-input:scale-100 group-focus-within/phone-input:opacity-50", layout === "input-group" && "group-focus-within/input-group:w-3.5 group-focus-within/input-group:scale-100 group-focus-within/input-group:opacity-50", countryOpen && "w-3.5 scale-100 opacity-50")}><ChevronsUpDown className="size-3.5" /></span> : <ChevronsUpDown className={cn("size-3.5 opacity-50", countryOpen && "opacity-100")} />);
    $[6] = countryOpen;
    $[7] = isGhost;
    $[8] = layout;
    $[9] = showChevron;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const chevron = t4;
  let t5;
  if ($[11] !== className) {
    t5 = cn("flex items-center", className);
    $[11] = className;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== country || $[14] !== showCode) {
    t6 = showCode && country && <span className="text-xs font-medium text-muted-foreground">{country}</span>;
    $[13] = country;
    $[14] = showCode;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== flag || $[17] !== t6) {
    t7 = <span className="flex items-center gap-1">{flag}{t6}</span>;
    $[16] = flag;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== chevron || $[20] !== t5 || $[21] !== t7) {
    t8 = <span className={t5}>{t7}{chevron}</span>;
    $[19] = chevron;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const content = t8;
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CommandInput placeholder="Search country..." />;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <CommandEmpty>No country found.</CommandEmpty>;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== actions || $[26] !== country) {
    t11 = countryListWithFlags.map(c => <CommandItem className="gap-2" key={c.code} onSelect={() => actions.setCountry(c.code)} value={c.name}><span aria-hidden="true" className="flex h-4 w-6 overflow-hidden rounded-sm [&_svg:not([class*='size-'])]:size-full"><ReactCountryFlag countryCode={c.code} title={c.name} /></span><span className="flex-1 text-sm">{c.name}</span><CheckIcon className={cn("ml-auto size-4", country === c.code ? "opacity-100" : "opacity-0")} /></CommandItem>);
    $[25] = actions;
    $[26] = country;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11) {
    t12 = <PopoverContent align="start" className="w-75 p-0" onClick={_temp} onMouseDown={_temp2}><Command>{t9}<CommandList>{t10}<CommandGroup>{t11}</CommandGroup></CommandList></Command></PopoverContent>;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const popover = t12;
  if (layout === "input-group") {
    const t13 = hideEmptyGhost && "w-0 scale-95 overflow-hidden opacity-0 transition-[opacity,transform] duration-150 ease-out";
    const t14 = isGhost && "pl-0";
    const t15 = countryOpen && "w-auto scale-100 opacity-100";
    let t16;
    if ($[30] !== t13 || $[31] !== t14 || $[32] !== t15) {
      t16 = cn(t13, "group-focus-within/input-group:w-auto group-focus-within/input-group:scale-100 group-focus-within/input-group:opacity-100", t14, t15);
      $[30] = t13;
      $[31] = t14;
      $[32] = t15;
      $[33] = t16;
    } else {
      t16 = $[33];
    }
    const t17 = country ? `Select country, ${countryName} selected` : "Select country, none selected";
    let t18;
    if ($[34] !== content || $[35] !== disabled || $[36] !== t17) {
      t18 = <PopoverTrigger asChild={true}><InputGroupButton aria-label={t17} className="gap-1 pr-0" data-slot="phone-input-country-trigger" disabled={disabled} type="button">{content}</InputGroupButton></PopoverTrigger>;
      $[34] = content;
      $[35] = disabled;
      $[36] = t17;
      $[37] = t18;
    } else {
      t18 = $[37];
    }
    let t19;
    if ($[38] !== actions.setCountryOpen || $[39] !== countryOpen || $[40] !== popover || $[41] !== t18) {
      t19 = <Popover onOpenChange={actions.setCountryOpen} open={countryOpen}>{t18}{popover}</Popover>;
      $[38] = actions.setCountryOpen;
      $[39] = countryOpen;
      $[40] = popover;
      $[41] = t18;
      $[42] = t19;
    } else {
      t19 = $[42];
    }
    let t20;
    if ($[43] !== t16 || $[44] !== t19) {
      t20 = <InputGroupAddon align="inline-start" className={t16}>{t19}</InputGroupAddon>;
      $[43] = t16;
      $[44] = t19;
      $[45] = t20;
    } else {
      t20 = $[45];
    }
    return t20;
  }
  const t13 = actions.setCountryOpen;
  const t14 = country ? `Select country, ${countryName} selected` : "Select country, none selected";
  const t15 = hideEmptyGhost && "w-0 scale-95 overflow-hidden px-0 opacity-0 transition-[opacity,transform] duration-150 ease-out";
  const t16 = !hideEmptyGhost && "px-2";
  const t17 = countryOpen && "w-auto scale-100 opacity-100";
  let t18;
  if ($[46] !== t15 || $[47] !== t16 || $[48] !== t17) {
    t18 = cn("flex gap-1", t15, t16, "group-focus-within/phone-input:w-auto group-focus-within/phone-input:scale-100 group-focus-within/phone-input:opacity-100", t17);
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  const t19 = inputVariant === "ghost" ? "ghost" : "outline";
  let t20;
  if ($[50] !== content || $[51] !== disabled || $[52] !== t14 || $[53] !== t18 || $[54] !== t19) {
    t20 = <PopoverTrigger asChild={true} data-sentry-element="PopoverTrigger" data-sentry-source-file="country-select.tsx"><Button aria-label={t14} className={t18} data-slot="phone-input-country-trigger" disabled={disabled} type="button" variant={t19} data-sentry-element="Button" data-sentry-source-file="country-select.tsx">{content}</Button></PopoverTrigger>;
    $[50] = content;
    $[51] = disabled;
    $[52] = t14;
    $[53] = t18;
    $[54] = t19;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== actions.setCountryOpen || $[57] !== countryOpen || $[58] !== popover || $[59] !== t20) {
    t21 = <Popover onOpenChange={t13} open={countryOpen} data-sentry-element="Popover" data-sentry-component="PhoneInputCountrySelect" data-sentry-source-file="country-select.tsx">{t20}{popover}</Popover>;
    $[56] = actions.setCountryOpen;
    $[57] = countryOpen;
    $[58] = popover;
    $[59] = t20;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  return t21;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}